import { Dialog } from "@sortera/react-components";
import styles from "./writing-guide.module.css";

// Built on the "Att beskriva vad du vill ha" section of the Factory's README, rewritten for this
// app: the rest of that page is about running the pipeline in DevOps, which this app does for you.

const EXAMPLE = [
  "Jag vill kunna se alla containrar vi har utplacerade hos kunder.",
  "En lista med en rad per container. För varje rad vill jag se vilken kund det är, vilken adress containern står på, vad den är till för — blandat avfall, trä, metall, gips — när vi satte ut den, och hur länge sedan det är den tömdes.",
  "Det viktigaste: jag vill kunna filtrera fram de som stått still för länge, mer än två veckor utan tömning. Det är de som kostar oss pengar.",
  "Vissa containrar har aldrig tömts sedan vi satte ut dem. Det ska synas som något annat än ”tömdes för länge sedan” — det är olika problem.",
  "Fyll den med påhittad data så det ser ut som en riktig dag. Ett tjugotal containrar, några kvarglömda.",
];

const PRINCIPLES = [
  {
    title: "Nämn varje uppgift",
    text: "Kund, adress, ändamål, när den sattes ut, hur länge sedan den tömdes. Det du lämnar ute får Claude gissa sig till.",
  },
  {
    title: "Ta med undantagen",
    text: "”Aldrig tömd” är ett annat problem än ”tömd för länge sedan”. Sådana skillnader är självklara för dig och osynliga för alla andra.",
  },
  {
    title: "Säg varför",
    text: "”Det är de som kostar oss pengar” säger vad appen är till för — och styr fler beslut än någon detaljerad beskrivning.",
  },
];

/** How to ask for something so Claude builds the right thing, in a pop-up over the current page. */
export function WritingGuideDialog({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <Dialog.Content className={styles.dialog} title="Så beskriver du vad du vill ha" closeLabel="Stäng">
        <Dialog.Body className={styles.body}>
          <div className={styles.guide}>
            <section className={styles.explain}>
              <p className="sc-kicker">Din verksamhet, inte tekniken</p>
              <h2 className={`sc-heading ${styles.heading}`}>Berätta vad du vill se</h2>
              <p className={styles.lead}>
                Du behöver inte veta hur något byggs. Det Claude inte kan veta är hur er verksamhet fungerar — så
                beskriv vad en människa ska se på skärmen, och varför det spelar roll.
              </p>

              <ol className={styles.principles}>
                {PRINCIPLES.map((p, i) => (
                  <li key={p.title} className={styles.principle}>
                    <span className={styles.number}>{i + 1}</span>
                    <div>
                      <h3 className={styles.principleTitle}>{p.title}</h3>
                      <p className={styles.principleText}>{p.text}</p>
                    </div>
                  </li>
                ))}
              </ol>

              <p className={styles.note}>
                Be gärna om påhittad data — tillräckligt mycket för att det ska likna en riktig dag. Data som är för
                städad döljer just de fall som är värda att hitta.
              </p>
            </section>

            <figure className={styles.example}>
              <figcaption className="sc-kicker">Så kan det låta</figcaption>
              <blockquote className={styles.quote}>
                {EXAMPLE.map((line) => (
                  <p key={line}>{line}</p>
                ))}
              </blockquote>
            </figure>
          </div>
        </Dialog.Body>
      </Dialog.Content>
    </Dialog>
  );
}
